import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AppMaterialModule} from "../app/app-material.module";
import {FirebaseService} from "../app/firebase.service";
import {SigninButtonComponent} from "../app/signin-button.component";
import {BuchungOptionenComponent} from "../buchung/buchung-optionen.component";
import {BuchungComponent} from "../buchung/buchung.component";
import {RechnungComponent} from "../buchung/rechnung.component";
import {StammdatenComponent} from "../buchung/stammdaten.component";
import {TeilnehmerComponent} from "../buchung/teilnehmer.component";
import {KontoComponent} from "../kunde/konto.component";
import {KundeBuchungenComponent} from "../kunde/kunde-buchungen.component";
import {KundeRechnungComponent} from "../kunde/kunde-rechnung.component";
import {KundeZahlungComponent} from "../kunde/kunde-zahlung.component";
import {KundeZahlungenComponent} from "../kunde/kunde-zahlungen.component";
import {PaypalButtonComponent} from "../kunde/paypal-button.component";
import {PaypalPlusComponent} from "../kunde/paypal-plus.component";
import {SyncValidatorComponent} from "../utils/base.component";
import {DialogComponent} from "../utils/dialog.component";
import {DialogService} from "../utils/dialog.service";
import {NamePreisPipe} from "../utils/name-preis.pipe";
import {NamePipe} from "../utils/name.pipe";
import {Preis2Pipe, PreisPipe} from "../utils/preis.pipe";
import {SigninComponent} from "../utils/signin.component";
import {BuchungRoutingModule} from "./buchung-routing.module";
import {CoronaHinweisComponent} from "./corona-hinweis.component";
import {FirebaseUIModule} from "firebaseui-angular";

@NgModule({
    declarations: [
        BuchungComponent,
        BuchungOptionenComponent,
        CoronaHinweisComponent,
        DialogComponent,
        KontoComponent,
        KundeBuchungenComponent,
        KundeRechnungComponent,
        KundeZahlungComponent,
        KundeZahlungenComponent,
        NamePipe,
        NamePreisPipe,
        PaypalButtonComponent,
        PaypalPlusComponent,
        PreisPipe,
        Preis2Pipe,
        RechnungComponent,
        SigninComponent,
        SigninButtonComponent,
        SyncValidatorComponent,
        StammdatenComponent,
        TeilnehmerComponent
    ],
    imports: [
        CommonModule,
        AppMaterialModule,
        BuchungRoutingModule,
        FirebaseUIModule
    ],
    exports: [
        BuchungComponent,
        BuchungOptionenComponent,
        CoronaHinweisComponent,
        DialogComponent,
        KontoComponent,
        KundeBuchungenComponent,
        KundeRechnungComponent,
        KundeZahlungComponent,
        KundeZahlungenComponent,
        NamePipe,
        NamePreisPipe,
        PaypalButtonComponent,
        PreisPipe,
        Preis2Pipe,
        RechnungComponent,
        SigninComponent,
        SigninButtonComponent,
        SyncValidatorComponent,
        StammdatenComponent,
        TeilnehmerComponent
    ],
    providers: [
        DialogService,
        FirebaseService,
        PreisPipe,
    ]
})
export class BuchungModule { }
